import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';

/**
 * @title Chip
 */
@Component({
    selector: 'app-chip',
    imports: [MatIconModule, MatRippleModule],
    templateUrl: './chip.component.html',
    styleUrl: './chip.component.scss',
})
export class ChipComponent implements OnChanges {
    @Input() disabled = false;
    @Input() clickable = true;
    @Input() defaultSelected = false;
    @Input() dataQa = '';
    @Output() clicked = new EventEmitter();

    selected = false;

    ngOnChanges(changes: SimpleChanges): void {
        const defaultSelectedChange = changes['defaultSelected'];
        this.selected = defaultSelectedChange.currentValue;
    }

    onClick() {
        if (this.clickable) {
            this.selected = !this.selected;
            this.clicked.emit();
        }
    }
}
